export const useInsuranceListKey = {
  all: () => [...useInsuranceListKey.base, "all"] as const,
  base: ["insurance-carriers"] as const,
};
